import { useState } from 'react';
import { useMediaQuery } from '@mui/material';

// const EMAIL_REGEX = new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$');
export const useStoreState = <T extends Record<string, any>>(func: () => T): T => {
  const [storeState] = useState(func);

  return storeState;
};

export const roundToPrecision = (value: number, fractionDigits?: number): number => {
  const multiplier = Math.pow(10, fractionDigits || 0);

  return Math.round(value * multiplier) / multiplier;
};

export const displayStringNumber = (value: number) => {
  return value.toLocaleString('en-US');
  // return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
};

export const isValidEmail = (email: string): boolean => {
  const re = /\S+@\S+\.\S+/;

  return re.test(email);
};

export const isSmall = (): boolean => {
  return useMediaQuery('(max-width:600px)');
};

export const isSmallerThan = (width: number): boolean => {
  return useMediaQuery(`'(max-width:${width}px)`);
};
